import React from 'react'

export default (props: any) => (
  <svg {...props} width="66" height="51" viewBox="0 0 66 51" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M65.5 17.013H0.300003V33.465H65.5V17.013Z" fill="#0052B4" />
    <path d="M65.5 33.465H0.300003V50.02H65.5V33.465Z" fill="#D80027" />
    <path d="M65.5 0.559998H0.300003V17.012H65.5V0.559998Z" fill="white" />
    <path d="M6.2 10.8V25.2C6.2 33.4 16.9 35.9 16.9 35.9C16.9 35.9 27.6 33.4 27.6 25.2V10.8H6.2Z" fill="white" />
    <path
      d="M8.7 10.8V25.2C8.68218 26.1787 8.92369 27.1448 9.4 28H24.5C24.9879 27.1494 25.2302 26.1801 25.2 25.2V10.8H8.7Z"
      fill="#D80027"
    />
    <path
      d="M21.8 20.7H18V18.3H20.5V15.8H18V13.3H15.6V15.8H13.1V18.3H15.6V20.7H11.8V23.2H15.6V25.7H18V23.2H21.8V20.7Z"
      fill="white"
    />
    <path
      d="M12.7 31.3C13.9786 32.0833 15.358 32.6889 16.8 33.1C18.2555 32.727 19.6403 32.119 20.9 31.3C22.3135 30.4865 23.4865 29.3135 24.3 27.9C23.5682 27.3838 22.6956 27.1046 21.8 27.1C21.4636 27.0836 21.1265 27.1173 20.8 27.2C20.4564 26.426 19.8956 25.7683 19.1856 25.3068C18.4755 24.8453 17.6468 24.5998 16.8 24.6C15.9475 24.5729 15.1072 24.8076 14.3921 25.2724C13.6769 25.7372 13.1213 26.4099 12.8 27.2C12.4735 27.1173 12.1364 27.0836 11.8 27.1C10.9044 27.1046 10.0318 27.3838 9.3 27.9C10.1416 29.2917 11.3083 30.4584 12.7 31.3V31.3Z"
      fill="#0052B4"
    />
    <path d="M65.5 0.5H0.5V50.5H65.5V0.5Z" stroke="#9F9D9D" />
  </svg>
)
